// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"RelatedArticles_swiper-slide-active__me0N7","wrapper":"RelatedArticles_wrapper__EM7st","title":"RelatedArticles_title__Pz59J"};